import { C2bOmsService } from '../../services';
import types from './types';

const orderRequest = () => (
    {
        type: types.ORDER_REQUEST,
    }
);
const orderResponse = () => (
    {
        type: types.ORDER_RESPONSE,
    }
);

const fetchWonDeals = (payload) => (dispatch) => {
    dispatch(orderRequest());
    return new Promise((resolve, reject) => {
        C2bOmsService.fetchWonDeals(payload)
            .then(response => {
                resolve(response.data);
            })
            .catch(error => reject(error))
            .finally(() => dispatch(orderResponse()));
    });
};

export {
    fetchWonDeals,
};
